import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import DateDesignerLeadFilter from './DateDesignerLeadFilter';
import ListView from '../shared/lists/ListView';
import MonthlyInstallationItem from './MonthlyInstallationItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import ExportButton from '../shared/buttons/ExportButton';

const MonthlyInstallation = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/monthlyinstallation`;

    useEffect(() => {
        setUrl(postUrl);
    }, []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Customer"
                    sort={pageInfo}
                    sortName="CustomerName"
                />
                <SortableTh
                    content="Designer"
                    sort={pageInfo}
                    sortName="Designer"
                />
                <SortableTh
                    content="Install"
                    sort={pageInfo}
                    sortName="InstallDate"
                />
                <SortableTh
                    content="Total"
                    sort={pageInfo}
                    sortName="JobTotal"
                />
                <SortableTh
                    content="Balance"
                    sort={pageInfo}
                    sortName="BalanceDue"
                />
                <SortableTh
                    content="Paid"
                    sort={pageInfo}
                    sortName="PaidInFull"
                />
                <SortableTh
                    content="Lead Source"
                    sort={pageInfo}
                    sortName="LeadSource"
                />
                <SortableTh
                    content="Sub Source"
                    sort={pageInfo}
                    sortName="SubLeadSource"
                />
                <SortableTh
                    content="AR Note"
                    sort={pageInfo}
                    sortName="ArNote"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/monthlyinstallation"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <MonthlyInstallationItem
            item={item}
            key={item.id}
        />
    );

    return (
        <Row>
            <Col>
                <DateDesignerLeadFilter
                    filter={filter}
                    setFilter={setFilter}
                />
                <Row className="pb-5 mt-3">
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default MonthlyInstallation;